export default __webpack_public_path__ + "static/media/Eva sharma Resume.6d17a6d6.pdf";